import apiUrl from '@/api/api'
import request from '@/lib/request/request'

export function getSign(params) {
  return request({
    url: apiUrl.getSignature,
    method: 'post',
    data: {
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/requestList.js